import { CreateAllPanesState } from "common/components/modal/panels/types/PanelConfigTypes"

export enum MOVE_TYPES {
    VIEW_TO_VIEW = "viewToView",
    MEDIAS_TO_VIEW = "mediaToView",
}

export enum MOVE_RESOURCE_PANE_IDS {
    VIEW_SELECTOR = "VIEW_SELECTOR",
    AUTHZ_UPDATE_STRATEGY = "AUTHZ_UPDATE_STRATEGY",
}

export interface IMoveAuthzUpdateStrategyPaneState {
    viewIds: string[]
}

export type IMoveResourceAllPaneState = CreateAllPanesState<
    MOVE_RESOURCE_PANE_IDS,
    {
        [MOVE_RESOURCE_PANE_IDS.VIEW_SELECTOR]: {}
        [MOVE_RESOURCE_PANE_IDS.AUTHZ_UPDATE_STRATEGY]: IMoveAuthzUpdateStrategyPaneState
    }
>
